/* Natolino Namensposter v1. Same geometry, outlines and kerning as natolino/services/names/svg.py. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.NLNames = api; api.boot(); }
}(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  const VERSION = 'names-2026-11-v1';
  const STYLE = 'namensposter';
  const MAX = 16, STACK_MAX = 7;
  const NAME_RE = /^[A-Za-zÀ-ÖØ-öø-ňŊ-ž][A-Za-zÀ-ÖØ-öø-ňŊ-ž \-'’]*$/u;
  const FORMATS = {'30x40': [300, 400], '50x70': [500, 700]};
  const PALETTES = {
    kirsche: ['#F3E6D3', '#A9BC97', '#B8322A', '#FBF4E8', '#7FA3C7', '#B8322A', '#E08A2E'],
    salbei: ['#F1EEDF', '#B9C6A2', '#C2552F', '#FCF7EC', '#5E7F55', '#4A3428', '#D79A2B'],
    senf: ['#F6E7C1', '#DDAF4A', '#8E3B2E', '#FDF6E6', '#3F6E8C', '#8E3B2E', '#8E3B2E'],
    ozean: ['#E7EFF2', '#9DBBCE', '#D99A32', '#FBF7EE', '#2F5A78', '#2F5A78', '#D99A32'],
    rosa: ['#F8E9E6', '#E8AFB6', '#9C2F4F', '#FFF8F3', '#D7697F', '#9C2F4F', '#E4A13A'],
  };
  const PAL_KEYS = ['ground', 'ground_accent', 'frame', 'panel', 'initial', 'name', 'star'];
  const PATTERNS = ['streifen', 'karo', 'uni'];
  const LAYOUTS = ['initiale', 'schrift', 'stapel'];
  const STARS = [[0.15, 0.12, 0.13, 12], [0.86, 0.19, 0.10, -8], [0.10, 0.50, 0.08, 30],
    [0.89, 0.55, 0.12, 5], [0.16, 0.92, 0.09, -20], [0.85, 0.91, 0.11, 18]];

  const COPY = {
    de: {eyebrow:'Namensposter · personalisiert', title:'Ein Name, der an der Wand strahlt.', intro:'Große Initiale, Sterne und ein gewellter Rahmen – in fünf Farbwelten. Ihr seht sofort, wie euer Poster gedruckt wird.',
      name:'Name', placeholder:'Euer Wunschname', hint:'Bis zu 16 Buchstaben. Bitte prüft die Schreibweise in der Vorschau.', layout:'Layout', palette:'Farbwelt', pattern:'Hintergrund', size:'Format', frame:'Ausführung',
      layouts:{initiale:'Initiale', schrift:'Schrift', stapel:'Buchstabenturm'}, palettes:{kirsche:'Kirsche', salbei:'Salbei', senf:'Senf', ozean:'Ozean', rosa:'Rosa'}, patterns:{streifen:'Streifen', karo:'Karo', uni:'Uni'},
      frames:{none:'Ohne Rahmen', black:'Rahmen Schwarz', white:'Rahmen Weiß', canvas:'Leinwand'}, add:'In den Warenkorb', adding:'Wird hinzugefügt …', added:'Im Warenkorb', cart:'Zum Warenkorb',
      error:'Bitte einen Namen mit 1–16 lateinischen Buchstaben eingeben. Leerzeichen, Bindestrich und Apostroph sind möglich.', cartError:'Das Hinzufügen hat nicht geklappt. Bitte versucht es erneut.',
      review:'Noch nicht bestellbar', priceNote:'inkl. MwSt. · zzgl. Versand', note:'Wir drucken genau diese Vorschau.', design:'Gestaltung', label:'Namensposter'},
    hr: {eyebrow:'Poster s imenom · personalizirano', title:'Ime koje sja na zidu.', intro:'Veliko početno slovo, zvjezdice i valoviti okvir – u pet svjetova boja. Odmah vidite kako će poster biti otisnut.',
      name:'Ime', placeholder:'Željeno ime', hint:'Do 16 slova. Provjerite ime na pretpregledu.', layout:'Raspored', palette:'Boje', pattern:'Pozadina', size:'Format', frame:'Izvedba',
      layouts:{initiale:'Inicijal', schrift:'Rukopis', stapel:'Toranj slova'}, palettes:{kirsche:'Trešnja', salbei:'Kadulja', senf:'Senf', ozean:'Ocean', rosa:'Roza'}, patterns:{streifen:'Pruge', karo:'Karo', uni:'Jednobojno'},
      frames:{none:'Bez okvira', black:'Crni okvir', white:'Bijeli okvir', canvas:'Platno'}, add:'Dodaj u košaricu', adding:'Dodajemo …', added:'Dodano u košaricu', cart:'U košaricu',
      error:'Unesite ime s 1–16 latiničnih slova. Dopušteni su razmaci, crtica i apostrof.', cartError:'Dodavanje nije uspjelo. Pokušajte ponovno.',
      review:'Još nije dostupno za narudžbu', priceNote:'PDV uključen · dostava se obračunava zasebno', note:'Tiskamo točno ovaj pretpregled.', design:'Dizajn', label:'Poster s imenom'},
    en: {eyebrow:'Name poster · personalised', title:'A name that shines on the wall.', intro:'A big initial, stars and a scalloped frame – in five colourways. You see exactly how your poster will be printed.',
      name:'Name', placeholder:'Your chosen name', hint:'Up to 16 letters. Please check the spelling in your preview.', layout:'Layout', palette:'Colourway', pattern:'Background', size:'Size', frame:'Finish',
      layouts:{initiale:'Initial', schrift:'Script', stapel:'Letter tower'}, palettes:{kirsche:'Cherry', salbei:'Sage', senf:'Mustard', ozean:'Ocean', rosa:'Rose'}, patterns:{streifen:'Stripes', karo:'Gingham', uni:'Plain'},
      frames:{none:'Without frame', black:'Black frame', white:'White frame', canvas:'Canvas'}, add:'Add to cart', adding:'Adding …', added:'Added to cart', cart:'View cart',
      error:'Enter a name with 1–16 Latin letters. Spaces, hyphens and apostrophes are welcome.', cartError:'Could not add this poster. Please try again.',
      review:'Not available to order yet', priceNote:'Tax included · shipping calculated separately', note:'We print exactly this preview.', design:'Design', label:'Name poster'},
  };
  function language(locale) { const k = String(locale || '').toLowerCase().split('-')[0]; return COPY[k] ? k : 'en'; }

  /* Python's round(): half to even. */
  function pyRound(x) { const f = Math.floor(x), d = x - f; if (Math.abs(d - 0.5) < 1e-12) return f % 2 === 0 ? f : f + 1; return Math.round(x); }
  function n(x) { return x.toFixed(3); }

  function normalizeName(value) {
    if (typeof value !== 'string') throw new Error('name');
    const name = value.normalize('NFC').trim().replace(/\s+/gu, ' ');
    if (!name || Array.from(name).length > MAX || !NAME_RE.test(name)) throw new Error('name');
    return name;
  }
  function palette(key) { const p = {}; PALETTES[key].forEach((c, i) => { p[PAL_KEYS[i]] = c; }); return p; }
  function checkSpec(spec) {
    if (!LAYOUTS.includes(spec.layout) || !PALETTES[spec.palette] || !PATTERNS.includes(spec.pattern) || !FORMATS[spec.size]) throw new Error('spec');
    return {...spec, name: normalizeName(spec.name)};
  }

  class Pather {
    constructor(font) { this.f = font; }
    get cap() { return this.f.cap; }
    layout(text, tracking) {
      const chars = Array.from(text), t = tracking * this.f.units;
      return chars.map((c, i) => {
        const g = this.f.glyphs[c] || ['', this.f.units / 2];
        let adv = g[1] + t;
        if (i + 1 < chars.length) adv += this.f.kern[c + chars[i + 1]] || 0; else adv -= t;
        return [g[0], adv];
      });
    }
    width(text, size, tracking) { return this.layout(text, tracking).reduce((s, g) => s + g[1], 0) * size / this.f.units; }
    path(text, size, cx, baseline, tracking, colour) {
      const s = size / this.f.units, lay = this.layout(text, tracking);
      let cursor = cx - lay.reduce((a, g) => a + g[1], 0) * s / 2;
      const parts = [];
      lay.forEach(([d, adv]) => { if (d) parts.push(`<path transform="matrix(${s} 0 0 ${-s} ${cursor} ${baseline})" d="${d}"/>`); cursor += adv * s; });
      return `<g fill="${colour}">${parts.join('')}</g>`;
    }
  }

  function box(x, y, w, h) { return {x, y, w, h, inset(b) { return box(x + b, y + b, w - 2 * b, h - 2 * b); }, at(fx, fy) { return [x + fx * w, y + fy * h]; }}; }

  function ground(pattern, w, h, p) {
    const out = [`<rect width="${w}" height="${h}" fill="${p.ground}"/>`];
    if (pattern === 'streifen') {
      const step = w / pyRound(w / 14);
      for (let x = 0; x < pyRound(w / step); x++) out.push(`<rect x="${n(x * step)}" y="0" width="${n(step / 2)}" height="${h}" fill="${p.ground_accent}"/>`);
    } else if (pattern === 'karo') {
      const step = w / pyRound(w / 12), cols = [], rows = [];
      for (let i = 0; i < pyRound(w / step); i++) cols.push(`<rect x="${n(i * step)}" y="0" width="${n(step / 2)}" height="${h}"/>`);
      for (let j = 0; j < Math.ceil(h / step); j++) rows.push(`<rect x="0" y="${n(j * step)}" width="${w}" height="${n(step / 2)}"/>`);
      out.push(`<g fill="${p.ground_accent}" fill-opacity="0.55">${cols.join('')}</g>`, `<g fill="${p.ground_accent}" fill-opacity="0.55">${rows.join('')}</g>`);
    }
    return out;
  }

  function frame(outer, p, u) {
    const out = [`<rect x="${n(outer.x)}" y="${n(outer.y)}" width="${n(outer.w)}" height="${n(outer.h)}" fill="${p.frame}"/>`];
    const circles = [], r = 3.4 * u;
    [[outer.w, outer.x, true], [outer.h, outer.y, false]].forEach(([len, start, hor]) => {
      const count = Math.max(2, pyRound(len / (2 * r))), step = len / count;
      for (let i = 0; i <= count; i++) {
        const pos = start + i * step;
        const pairs = hor ? [[pos, outer.y], [pos, outer.y + outer.h]] : [[outer.x, pos], [outer.x + outer.w, pos]];
        pairs.forEach(([cx, cy]) => circles.push(`<circle cx="${n(cx)}" cy="${n(cy)}" r="${n(step * 0.56)}"/>`));
      }
    });
    out.push(`<g fill="${p.frame}">${circles.join('')}</g>`);
    const panel = outer.inset(2.2 * u);
    out.push(`<rect x="${n(panel.x)}" y="${n(panel.y)}" width="${n(panel.w)}" height="${n(panel.h)}" fill="${p.panel}"/>`);
    const dots = panel.inset(2.6 * u);
    out.push(`<rect x="${n(dots.x)}" y="${n(dots.y)}" width="${n(dots.w)}" height="${n(dots.h)}" fill="none" stroke="${p.frame}" stroke-width="${n(0.9 * u)}" stroke-linecap="round" stroke-dasharray="0 ${n(2.2 * u)}"/>`);
    return [out, dots.inset(2.0 * u)];
  }

  function star(cx, cy, size, rot, colour) {
    const pts = [];
    for (let k = 0; k < 10; k++) {
      const rad = k % 2 === 0 ? size / 2 : size / 4.6, a = (rot - 90 + k * 36) * Math.PI / 180;
      pts.push(`${n(cx + rad * Math.cos(a))},${n(cy + rad * Math.sin(a))}`);
    }
    return `<polygon points="${pts.join(' ')}" fill="${colour}" stroke="${colour}" stroke-width="${n(size * 0.08)}" stroke-linejoin="round"/>`;
  }
  function stars(panel, colour, avoid) {
    return STARS.filter(([, fy]) => !avoid || !(avoid[0] <= fy && fy <= avoid[1])).map(([fx, fy, s, r]) => star(...panel.at(fx, fy), s * panel.w, r, colour));
  }
  function letterCount(name) { return Array.from(name.replace(/ /g, '')).length; }
  function starGap(spec) { return spec.layout === 'stapel' && letterCount(spec.name) > STACK_MAX ? [0.30, 0.80] : null; }

  function fit(pather, text, panel, baseF, capF, widthF, colour, tracking) {
    let size = capF * panel.h / pather.cap;
    const w = pather.width(text, size, tracking);
    if (w > widthF * panel.w) size *= widthF * panel.w / w;
    return pather.path(text, size, panel.x + panel.w / 2, panel.y + baseF * panel.h, tracking, colour);
  }
  function lettering(spec, panel, p, fonts) {
    if (spec.layout === 'stapel') {
      const text = spec.name.toUpperCase(), letters = Array.from(text).filter(c => c !== ' '), rounded = fonts.rounded;
      if (letters.length > STACK_MAX) return [star(...panel.at(0.5, 0.33), 0.62 * panel.w, 0, p.initial), fit(rounded, text, panel, 0.74, 0.16, 0.84, p.name, 0.02)];
      const colours = [p.initial, p.name, p.star], slot = 0.84 / Math.max(letters.length, 4);
      return letters.map((c, i) => fit(rounded, c, panel, 0.08 + slot * (i + 0.5) + slot * 0.36, slot * 0.78, 0.6, colours[i % 3], 0));
    }
    const ini = spec.layout === 'initiale';
    const initial = Array.from(spec.name)[0].toUpperCase();
    return [
      fit(ini ? fonts.rounded : fonts.serif, initial, panel, 0.56, 0.44, 0.70, p.initial, 0),
      fit(ini ? fonts.rounded : fonts.script, ini ? spec.name.toUpperCase() : spec.name, panel, 0.80, ini ? 0.085 : 0.12, 0.80, p.name, ini ? 0.04 : 0),
    ];
  }
  function svg(rawSpec, atlas) {
    const spec = checkSpec(rawSpec), [w, h] = FORMATS[spec.size], p = palette(spec.palette), u = w / 100;
    const fonts = {rounded: new Pather(atlas.fonts.rounded), serif: new Pather(atlas.fonts.serif), script: new Pather(atlas.fonts.script)};
    const outer = box(0, 0, w, h).inset(9.5 * u);
    const [fr, panel] = frame(outer, p, u);
    const body = [...ground(spec.pattern, w, h, p), ...fr, ...stars(panel, p.star, starGap(spec)), ...lettering(spec, panel, p, fonts)];
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${w}mm" height="${h}mm" viewBox="0 0 ${w} ${h}">${body.join('')}</svg>`;
  }

  function properties(spec, frameKey, lang) {
    const s = checkSpec(spec), c = COPY[language(lang)];
    return {Name: s.name, [c.design]: [c.layouts[s.layout], c.palettes[s.palette], c.patterns[s.pattern]].join(' · '),
      _style: STYLE, _names_version: VERSION, _layout: s.layout, _palette: s.palette, _pattern: s.pattern, _size: s.size, _frame: frameKey, _locale: language(lang)};
  }
  function variantFor(catalogue, size, frameKey) {
    const v = catalogue.variants.find(x => x.size === size && x.frame === frameKey);
    if (!v || !/^\d+$/.test(String(v.id)) || v.sku !== `NLN-${size.toUpperCase()}-${frameKey.toUpperCase()}`) throw new Error('variant');
    return v;
  }
  function money(cents, lang) { return new Intl.NumberFormat(lang, {style: 'currency', currency: 'EUR'}).format(cents / 100); }

  let atlasPromise = null;
  function loadAtlas(url) { if (!atlasPromise) atlasPromise = fetch(url).then(r => { if (!r.ok) throw new Error('atlas'); return r.json(); }); return atlasPromise; }
  function el(tag, attrs, text) { const e = document.createElement(tag); Object.entries(attrs || {}).forEach(([k, v]) => e.setAttribute(k, v)); if (text !== undefined) e.textContent = text; return e; }

  class NameBuilder {
    constructor(root, config) {
      this.root = root; this.cfg = config; this.lang = language(config.locale); this.c = COPY[this.lang]; this.busy = false;
      this.state = {name: '', layout: 'initiale', palette: 'kirsche', pattern: 'streifen', size: '30x40', frame: 'none'};
      const q = new URLSearchParams(location.search);
      ['layout', 'palette', 'pattern', 'size'].forEach(k => { if (q.get(k)) this.state[k] = q.get(k); });
      try { checkSpec({...this.state, name: 'A'}); } catch (e) { Object.assign(this.state, {layout: 'initiale', palette: 'kirsche', pattern: 'streifen', size: '30x40'}); }
      this.draw();
      loadAtlas(config.atlasURL).then(a => { this.atlas = a; this.update(); }).catch(() => { this.preview.textContent = this.c.cartError; });
    }
    group(legend, key, options, label, swatch) {
      const fs = el('fieldset', {class: 'nn-group'}); fs.append(el('legend', {}, legend));
      const row = el('div', {class: 'nn-options'});
      options.forEach(o => {
        const l = el('label', {class: 'nn-option' + (swatch ? ' nn-swatch' : '')}), r = el('input', {type: 'radio', name: 'nn-' + key, value: o});
        r.checked = this.state[key] === o; r.onchange = () => { this.state[key] = o; if (key === 'size') this.fixFrame(); this.update(); };
        l.append(r);
        if (swatch) { const s = el('span', {class: 'nn-dot', 'aria-hidden': 'true'}); s.style.background = `linear-gradient(135deg, ${PALETTES[o][2]} 50%, ${PALETTES[o][1]} 50%)`; l.append(s); }
        l.append(el('span', {}, label(o))); row.append(l);
      });
      fs.append(row); return fs;
    }
    fixFrame() { if (!this.cfg.catalogue.variants.some(v => v.size === this.state.size && v.frame === this.state.frame)) this.state.frame = 'none'; this.drawFrames(); }
    drawFrames() {
      this.frames.replaceChildren(el('legend', {}, this.c.frame));
      this.cfg.catalogue.variants.filter(v => v.size === this.state.size).forEach(v => {
        const l = el('label', {class: 'nn-variant'}), r = el('input', {type: 'radio', name: 'nn-frame', value: v.frame});
        r.checked = v.frame === this.state.frame; r.onchange = () => { this.state.frame = v.frame; this.update(); };
        l.append(r, el('span', {}, this.c.frames[v.frame]), el('strong', {}, money(v.price_cents, this.lang))); this.frames.append(l);
      });
    }
    draw() {
      const c = this.c, r = this.root; r.replaceChildren();
      const head = el('header', {class: 'nn-heading'}); head.append(el('p', {class: 'nn-eyebrow'}, c.eyebrow), el('h1', {}, c.title), el('p', {class: 'nn-intro'}, c.intro));
      const stage = el('div', {class: 'nn-stage'}); this.preview = el('div', {class: 'nn-preview', role: 'img'}); stage.append(this.preview);
      const form = el('form', {class: 'nn-controls'}); form.noValidate = true;
      const uid = 'nn-name-' + r.id, input = el('input', {id: uid, type: 'text', autocomplete: 'off', maxlength: 32, placeholder: c.placeholder, 'aria-describedby': uid + '-hint ' + uid + '-error'});
      input.oninput = () => { this.state.name = input.value; this.error.textContent = ''; input.removeAttribute('aria-invalid'); this.update(); }; this.input = input;
      this.error = el('p', {id: uid + '-error', class: 'nn-error', role: 'alert'});
      form.append(el('label', {for: uid, class: 'nn-label'}, c.name), input, el('p', {id: uid + '-hint', class: 'nn-hint'}, c.hint), this.error,
        this.group(c.layout, 'layout', LAYOUTS, o => c.layouts[o]), this.group(c.palette, 'palette', Object.keys(PALETTES), o => c.palettes[o], true),
        this.group(c.pattern, 'pattern', PATTERNS, o => c.patterns[o]),
        this.group(c.size, 'size', Object.keys(FORMATS).filter(s => this.cfg.catalogue.variants.some(v => v.size === s)), o => o.replace('x', ' × ') + ' cm'));
      this.frames = el('fieldset', {class: 'nn-group nn-frames'}); form.append(this.frames); this.drawFrames();
      this.price = el('p', {class: 'nn-price'}); this.submit = el('button', {type: 'submit', class: 'nn-primary nl-btn'}, this.cfg.orderingEnabled ? c.add : c.review);
      this.cartLink = el('a', {href: this.cfg.cartURL || '/cart', class: 'nn-cart-link', hidden: ''}, c.cart);
      form.append(this.price, el('p', {class: 'nn-hint'}, c.priceNote), this.submit, this.cartLink, el('p', {class: 'nn-hint'}, c.note));
      form.onsubmit = e => { e.preventDefault(); this.add(); };
      const grid = el('div', {class: 'nn-builder'}); grid.append(stage, form); r.append(head, grid);
    }
    spec() { const name = this.state.name.normalize('NFC').trim().replace(/\s+/gu, ' '); let shown = name || this.c.placeholder; try { normalizeName(shown); } catch (e) { shown = this.c.placeholder; } return {...this.state, name: shown}; }
    update() {
      const v = variantFor(this.cfg.catalogue, this.state.size, this.state.frame);
      this.price.textContent = money(v.price_cents, this.lang);
      if (!this.atlas) return;
      const spec = this.spec(), [w, h] = FORMATS[spec.size];
      this.preview.innerHTML = svg(spec, this.atlas);
      this.preview.dataset.frame = this.state.frame; this.preview.style.aspectRatio = `${w} / ${h}`;
      this.preview.setAttribute('aria-label', this.c.label + ' · ' + spec.name);
    }
    async add() {
      if (this.busy) return; let props, variant;
      try { props = properties(this.state, this.state.frame, this.lang); variant = variantFor(this.cfg.catalogue, this.state.size, this.state.frame); }
      catch (e) { this.error.textContent = this.c.error; this.input.setAttribute('aria-invalid', 'true'); this.input.focus(); return; }
      if (!this.cfg.orderingEnabled) { this.error.textContent = this.c.review; return; }
      this.busy = true; this.submit.disabled = true; this.submit.textContent = this.c.adding;
      try {
        const base = (this.cfg.rootURL || '/').replace(/\/$/, '');
        const liveR = await fetch(base + '/products/' + this.cfg.catalogue.handle + '.js', {headers: {Accept: 'application/json'}});
        if (!liveR.ok) throw new Error('product');
        const live = await liveR.json(), actual = (live.variants || []).find(x => String(x.id) === String(variant.id));
        if (!actual || !actual.available || actual.sku !== variant.sku || Number(actual.price) !== variant.price_cents) throw new Error('variant changed');
        const res = await fetch(this.cfg.addURL, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: variant.id, quantity: 1, properties: props}]})});
        if (!res.ok) throw new Error('cart');
        const body = await res.json(), line = (body.items || []).find(i => String(i.variant_id || i.id) === String(variant.id) && i.properties && i.properties.Name === props.Name);
        if (!line) throw new Error('cart');
        this.submit.textContent = this.c.added; this.cartLink.removeAttribute('hidden');
        document.dispatchEvent(new CustomEvent('natolino:names:add', {detail: {variant: String(variant.id), size: this.state.size}}));
      } catch (e) { this.error.textContent = this.c.cartError; this.submit.textContent = this.c.add; }
      finally { this.busy = false; this.submit.disabled = false; }
    }
  }

  function renderCart(node, p, atlas) {
    if (p._style !== STYLE || p._names_version !== VERSION) return false;
    try {
      node.innerHTML = svg({name: p.Name, layout: p._layout, palette: p._palette, pattern: p._pattern, size: p._size}, atlas);
      const [w, h] = FORMATS[p._size]; node.style.aspectRatio = `${w} / ${h}`;
      node.dataset.frame = p._frame; node.dataset.rendered = 'true';
      const img = node.parentElement && node.parentElement.querySelector('img.cart-items__media-image'); if (img) img.hidden = true;
      return true;
    } catch (e) { return false; }
  }
  function boot() {
    if (typeof document === 'undefined') return;
    document.querySelectorAll('[data-natolino-names]').forEach(s => {
      if (s.dataset.ready) return; const cfg = s.querySelector('[data-names-config]'); if (!cfg) return;
      s.dataset.ready = 'true'; new NameBuilder(s.querySelector('[data-names-root]'), JSON.parse(cfg.textContent));
    });
    /* The shared cart renderer decodes the properties and calls cartPreview(); re-run it now that we are loaded. */
    if (window.NLCartPreview) window.NLCartPreview.render();
  }
  /* Hook for natolino-cart-preview.js: true = this line is ours (rendered now or once the atlas arrives). */
  function cartPreview(node, p) {
    if (!p || p._style !== STYLE) return false;
    if (node.dataset.nnKey === node.dataset.properties && node.querySelector('svg')) return true;
    const cfg = document.querySelector('[data-nl-names-cart-config]');
    if (!cfg) return false;
    const key = node.dataset.properties;
    loadAtlas(JSON.parse(cfg.textContent).atlasURL).then(a => { if (renderCart(node, p, a)) node.dataset.nnKey = key; }).catch(() => {});
    return true;
  }
  return {VERSION, COPY, language, normalizeName, checkSpec, svg, properties, variantFor, renderCart, cartPreview, pyRound, boot};
}));
